import { render, staticRenderFns } from "./recommendDrawer.vue?vue&type=template&id=9b041a12"
import script from "./recommendDrawer.vue?vue&type=script&lang=js"
export * from "./recommendDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports